export default __webpack_public_path__ + "static/media/CSRealCase1-en.938368d8.jpg";